// src/App.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import CompanyPage from "./Pages/CompanyPage";
import Navbar from "./Pages/Navbar";


function App() {
  return (
    <div>
      <Navbar/>
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/company/:id" element={<CompanyPage />} />
      </Routes>
    </div>
  );
}

export default App;